import React from 'react'
import { Link } from 'react-router-dom'
import { SubscribeForm } from './SubscribeForm/SubscribeForm'
import { FooterMenu } from './Menu/Menu'
import { getContactCenterPhone } from 'shared/utils'
import styles from './Footer.module.scss'
import logo from 'assets/images/logo-red.svg'

const Footer = (): JSX.Element => {
  const year = new Date().getFullYear()
  const phone = getContactCenterPhone()

  return (
    <footer className={styles['footer']}>
      <div className="container">
        <div className={`${styles.row} row ${styles.row_first}`}>
          {/* Logo */}
          <div
            className={`${styles['col-logo']} col-xl-3 col-lg-3 col-md-3 col-xs-12`}
          >
            <img src={logo} alt="logo" />
            <div className={styles.phone}>
              <small className="text-secondary">Контакт-центр</small>
              <a href={`tel:${phone.href}`}>{phone.text}</a>
            </div>
          </div>

          <div
            className={`${styles['col-menu']} col-xl-2 col-lg-2 col-md-2 col-sm-3 col-xs-6`}
          >
            <FooterMenu index={0} />
          </div>

          <div
            className={`${styles['col-menu']} col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-6`}
          >
            <FooterMenu index={1} />
          </div>

          {/* subscribe */}
          <div
            className={`${styles['col-subscribe']} col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12`}
          >
            <SubscribeForm />
          </div>
        </div>
      </div>

      <div className={styles.row_last}>
        <div className="container">
          <div className="row">
            <div
              className={`col-xl-8 col-lg-5 col-md-5 col-sm-6 col-xs-12 ${styles['col-copy']}`}
            >
              <div className={styles.copy}>
                &copy; {year} KION. Все права защищены
              </div>
              <Link to="/compliance" rel="noreferrer">
                Комплаенс и деловая этика
              </Link>
              <a
                href={require('assets/docs/Пользовательское соглашение.docx')}
                target="_blank"
                rel="noreferrer"
                download="Пользовательское соглашение"
              >
                Пользовательское соглашение
              </a>
            </div>

            <div
              className={`col-xl-4 col-lg-7 col-md-7 col-sm-6 col-xs-12 ${styles['col-docs']}`}
            >
              <div className={styles.recaptcha}>reCAPTCHA</div>
              <div className={styles.docs}>
                <a
                  href="https://policies.google.com/privacy?hl=ru"
                  target="_blank"
                  rel="noreferrer"
                >
                  Конфиденциальность
                </a>
                <a
                  href="https://policies.google.com/terms?hl=ru"
                  target="_blank"
                  rel="noreferrer"
                >
                  Условия использования
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
